<template>
  <div id="app">
    <el-container>
      <el-header>
        <el-container>
          <el-aside width="250px">
          <h1 style="padding:0px;margin:0px;margin-top:8px;">
            <img src="./assets/logo.png" style="vertical-align: middle;height:40px;" alt="">
          </h1>
          </el-aside>
          <el-main style="margin:0px;padding:0px;">
            <div style="width:600px;height:59px;overflow:hidden;position:relative;">
              <el-menu style="border-right:0px solid #FFF;" 
              mode="horizontal"
              default-active="/home/subject"
              active-text-color="#409EFF"
              router>
              <el-menu-item index="/home/subject" style="font-size:16px;">
                <i class="fa fa-address-book"></i>&nbsp;
                <span slot="title">我的患者</span>
              </el-menu-item>
              <el-menu-item index="/home/project" style="font-size:16px;">
                <i class="fa fa-medkit"></i>&nbsp;
                <span slot="title">我发起的研究</span>
              </el-menu-item>
              <el-menu-item index="/home/projectattend" style="font-size:16px;">
                <i class="fa fa-plus-square"></i>&nbsp;
                <span slot="title">我参与的研究</span>
              </el-menu-item>
              <el-menu-item index="/home/group" style="font-size:16px;">
                <i class="fa fa-group"></i>&nbsp;
                <span slot="title">我的团队</span>
              </el-menu-item>
            </el-menu>
            </div>
  
          </el-main>
          <el-aside width="110px">
          <div style="float:left;margin-top:15px;padding-left:20px;">
          <el-popover
              placement="bottom"
              width="400"
              trigger="click"
              @show="loadUserInfo">
              
              <div v-if="(this.user.openid || '')==''" style="text-align:center">
        
                <div style="padding:8px;">
                  请先开启患者互动
                </div>
                <img :src="'/console/user/me?id=' + user.userid" style="width:300px;"/>
                <div style="padding:8px;">
                  请使用微信扫描二维码后刷新页面
                  
                </div>
              </div>
              <div v-else style="text-align:center">
                <div style="padding:8px;">
                  请用微信扫码加入交流
                </div>
                
                <img :src="'/console/user/qrcode?id=' + user.userid" style="width:300px;"/>
                <div style="padding:8px;">
                  {{this.user.username}} 医生
                  <br>
                  该二维码（{{this.user.weixin_expireddate}}前）有效
                </div>
              </div>
              
              
              <span slot="reference">
              <i  class="fa fa-drivers-license-o fa-fw" style="color:#767c85;font-size:25px;line-height:35px;cursor:pointer"></i>
              </span>
            </el-popover>
          </div>

          <div style="width:10px;margin-top:18px;float:left;text-align:center;">
          <el-divider direction="vertical" ></el-divider>
          </div>

            <div style="width:40px;margin-top:15px;float:right;">
              <el-popover
                placement="bottom"
                width="200"
                trigger="click"
                v-model="popoverProfile">
                <div style='text-align:center;'>您好，{{user.username}} 医生</div>
                <div style='text-align:center;'>{{user.email}}</div>
                <!-- <div style='text-align:center;' v-if="(user.openid ||'') !=''">
                  <img :src="'/console/user/qrcode?id=' + user.userid" style="width:150px;"/>
                </div> -->
                <el-divider></el-divider>
                <el-menu style="border-right:0px solid #FFF;" @select="SelectAppMenu" >
                  <el-menu-item index="1">
                    <i class="fa fa-user fa-fw"></i>&nbsp;
                    <span slot="title">个人资料</span>
                  </el-menu-item>

                  <el-menu-item index="2">
                    <i class="fa fa-key fa-fw"></i>&nbsp;
                    <span slot="title">修改密码</span>
                  </el-menu-item>

                  <el-menu-item index="3">
                    <i class="fa fa-drivers-license-o fa-fw"></i>&nbsp;
                    <span slot="title">研究二维码</span>
                  </el-menu-item>

                  <el-menu-item index="9">
                    <i class="fa fa-sign-out fa-fw"></i>&nbsp;
                    <span slot="title">退出</span>
                  </el-menu-item>
                </el-menu>
                <el-avatar slot="reference" :src="user.headimgurl" :size="35" style="cursor:pointer"></el-avatar>
              </el-popover>
            </div>
            
          </el-aside>
        </el-container>
      </el-header>
      <el-main style="padding:0px;">
        
        <router-view :key="$route.fullPath"/>
      </el-main>
      
    </el-container>
    
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      search:'',
      search_old:'',
      applogo:'../../assets/logo.png',
      formlist:[],
      subjectlist:[],
      projectlist:[],
      search_popover_visiable:false,
      activeSearch:'subject',
      user:{
        email: ''
      },
      popoverProfile:false,
      activeMenu:'/home/subject',
    }
  },

  created() {
    //检查一下token
    var token = localStorage.getItem("token") || "";
    if(token == ""){
      window.location.href = "/login.htm";
    }
  },
  mounted(){
    var _$http = this.$http;
    window.GetApiProxy = function(url, data, cb){
                  _$http.get(url, data).then(cb);
                }

    window.PostApiProxy = function(url, data, cb){
                  _$http.post(url, data).then(cb);
                }

    this.loadUserInfo();
    

  },
  computed:{
    filterSubjectlist(){
      var search = this.search;
      var subjectlist = this.subjectlist;
      return subjectlist.filter(function (item) {
          return item.subjectname.toLowerCase().indexOf(search.toLowerCase()) != -1 ||
                 (item.category || '').toLowerCase().indexOf(search.toLowerCase()) != -1    ||
                 (item.subjectnumber ||'').toLowerCase().indexOf(search.toLowerCase()) != -1 
                 
      });
    },
    filterFormlist(){
      var search = this.search;
      var formlist = this.formlist;
      return formlist.filter(function (item) {
          return item.name.toLowerCase().indexOf(search.toLowerCase()) != -1 ||
                (item.tags || '').toLowerCase().indexOf(search.toLowerCase()) != -1 
      });
    },
  },
  watch:{
    search(val){
      if(this.search_old == '' && val !='') this.getSearchData();
      this.search_old = val;
      this.search_popover_visiable = true;
    },
  },
  methods: {
    loadUserInfo(){
      this.$http.get('user/profile').then((res) => { 
        this.user = res.data.info;
      });
    },
    SelectAppMenu(index)
    {
      if(index == 1)
      {
        this.$router.push({ path: '/user/profile', query: {id:this.user.userid}})
        this.popoverProfile = false;
      }

      if(index == 2)
      {
        this.$router.push({ path: '/user/changepwd', query: {id:this.user.userid}})
        this.popoverProfile = false;
      }

      if(index == 3)
      {
        this.$router.push({ path: '/user/workcard', query: {id:this.user.userid}})
        this.popoverProfile = false;
      }

      if(index ==9)
      {
        this.$confirm("确定要离开系统吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
              
                localStorage.removeItem("token")
                window.location.href= "login.htm"
            }).catch(() => {
                console.log("cancel");
        });
      }
    },
    getSearchData(val){
      this.$http.get('subject/list').then((res) => { 
        console.log(res.data);
        this.subjectlist = res.data.list;
      });

      this.$http.get('form/list').then((res) => {
        if(!res) return;
        this.formlist = res.data.list;
      }); 

      
    },
    openSearchURL(path,id){
      this.$router.push({ path: path, query:{id: id}});
      this.search_popover_visiable = false;
    },
    openSearchURL_FORM(path,row){
      this.$router.push({ path: path, query:{id: row.formid,category:row.category}});
      this.search_popover_visiable = false;
    },
    showSearchPopOver(){
      
    },
  }
}
</script>

<style>
html,body,#app,.el-container{
        padding: 0px;
        margin: 0px;
        height: 100%;
    }

  .el-header {
    height: 54px;
    width: 100%;
    border-bottom: 1px solid #e7e9eb;
    padding: 0 24px;
    z-index: 1001;
    background-color: #fff;
    position: relative;
    box-sizing: border-box;
  }
  
  .el-aside {
    color: #333;
  }

  .el-input__inner[DangerColor="danger"] {
    background-color: #F56C6C; 
    border:0px solid red;
    background: #f2f5fa;
  }
  
  .el-input__inner[WarningColor="warning"] {
    background-color: #E6A23C; 
    border:0px solid red;
    background: #f2f5fa;
  }
  
  .el-input__inner[SuccessColor="success"] {
    background-color: #67C23A; 
    border:0px solid red;
    background: #f2f5fa;
  }

  .el-input__prefix {
    color: #409EFF !important;
    font-weight:bold !important;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }

  .starflag{
    color:#65676A;
  }
  .starflag_1{
    color:rgb(212, 70, 66);
  }
  .starflag_2{
    color:rgb(232, 140, 64);
  }
  .starflag_3{
    color:rgb(170, 64, 156);
  }
  .starflag_4{
    color:rgb(98, 165, 93);
  }
  .starflag_5{
    color:rgb(88, 158, 248);
  }


  /* 聊天框 */
  .dataShow{
    overflow-y: hidden;
    overflow-x: hidden;
    margin-bottom: -24px;
    margin-top: -24px;
    height: 2600px;
  
    margin-bottom: 1%;
    margin-top: 1%;
    background-color: #f5f5f5;
  }
  .aa{
    float: right;
    position: relative;
    display: inline-block;
    max-width: calc(40%);
    min-height: 35px;
    line-height: 2.1;
    font-size: 15px;
    padding: 10px 30px;
    text-align: left;
    word-break: break-all;
    background-color: #9eea6a;
    color: #000;
    border-radius: 20px;
    box-shadow: 0px 1px 7px -5px #000;
    border:0px solid #000;
    margin-top: 0;
    margin-right: 30px;
  }

  .aa-image {
    float: right;
    position: relative;
    display: inline-block;
    max-width: calc(40%);
    min-height: 35px;
    padding: 10px 30px;
    margin-top: 0;
    margin-right: 20px;
  }
  .aa:after {
    content: "";
    border-top: solid 20px #00800000;
    border-left: solid 30px #9eea6a;
    border-right: solid 30px #00800000;
    border-bottom: solid 20px #00800000;
    position: absolute;
    top: 20px;
    left: 100%;
    
    
  }
  .bb{
    display: inline-block;
    line-height:30px;
    font-style: normal;
    background-color: white;
    letter-spacing: 2px;
    position: relative;
    max-width: calc(40%);
    min-height: 35px;
    line-height: 2.1;
    font-size: 15px;
    padding: 10px 30px;
    text-align: left;
    word-break: break-all;
    border-radius: 4px;
    color: #000;
    box-shadow: 0px 1px 7px -5px #000;
    border:0px solid #000;
    margin-top: 0;
    margin-left: 80px;
  }

  .bb-image {
      display: inline-block;
  
      position: relative;
      max-width: calc(40%);
      min-height: 35px;
  
      margin-top: 0;
      margin-left: 80px;
    }
  
  .bb:after {
    content: "";
    border-top: solid 20px #00800000;
    border-left: solid 30px #00800000;
    border-right: solid 30px white;
    border-bottom: solid 20px #00800000;
    position: absolute;
    top: 20px;
    right: 100%;
 
  }

</style>